const EnhancesRecoveryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.1296 29.3691L23.8588 34.318C24.2432 35.1636 25.258 35.5141 26.0823 35.0858C26.8197 34.7027 27.1481 33.824 26.8426 33.0511L24.5723 27.3062C24.4053 26.8838 24.3027 26.4388 24.2679 25.9859L23.5974 17.2686C23.5179 16.235 22.7327 15.3945 21.7069 15.2449L15.5202 14.3426C13.2522 14.0118 11.0429 15.2383 10.1242 17.3383L7.17114 24.0884"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6205 21.1484L21.0069 30.3531V34.5147L23.7068 49.0078L24.4565 61.2176C24.5158 62.1832 23.7487 62.9989 22.7813 62.9989H22.7406C21.8832 62.9989 21.1636 62.3527 21.0719 61.5002L19.7796 49.4988L16.8342 41.7668"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0796 39.0655L15.6239 49.927L13.5456 61.613C13.4032 62.414 12.7068 62.9976 11.8932 62.9976C10.9099 62.9976 10.1372 62.156 10.2209 61.1762L11.1721 50.0413L10.4525 35.9973C10.4525 35.9973 9.88056 34.0932 10.0668 31.4688"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8652 1.9131L21.4145 1.80033C19.6478 1.35832 17.8573 2.43224 17.4153 4.19899L16.5683 7.58434C16.1264 9.35109 17.2002 11.1416 18.9669 11.5837L19.4177 11.6964C21.1844 12.1384 22.9749 11.0645 23.4168 9.29777L24.2638 5.91242C24.7058 4.14566 23.6319 2.35511 21.8652 1.9131Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7061 27.8297L17.9699 27.8126C18.8835 27.802 19.6286 28.7506 19.6286 29.9246C19.6286 31.0911 18.8926 32.0367 17.9848 32.0367H16.293"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47155 23.3905C6.75037 25.142 5.82314 27.2025 6.0292 28.5419C6.59153 32.1972 16.2929 32.2509 16.2929 32.2509C16.2929 32.2509 16.0227 31.7358 16.0227 30.3964C16.0227 28.5419 17.362 26.3783 17.362 26.3783C17.362 26.3783 8.94385 25.111 7.48652 23.375"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3621 26.3762C17.3621 26.3762 22.0624 18.1979 22.0624 15.3326L20.7409 15.1094C20.7409 15.1094 15.585 22.9847 12.0435 25.2986"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.2517 31.2191C51.99 31.2191 58.2631 24.9458 58.2631 17.2072C58.2631 9.46866 51.99 3.19531 44.2517 3.19531C36.5134 3.19531 30.2402 9.46866 30.2402 17.2072C30.2402 24.9458 36.5134 31.2191 44.2517 31.2191Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2117 17.1328H33.0566"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.7896 23.1647L34.5213 22.7422"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1707 27.5989L38.5931 26.8672"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1812 29.2434V28.3984"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.2105 27.6692L49.7881 26.9375"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.6433 23.2897L53.9116 22.8672"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.2917 17.2734H55.4468"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.7139 11.25L53.9822 11.6725"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3326 6.8125L49.9102 7.54424"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.322 5.16406V6.009"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2927 6.74219L38.7152 7.47393"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8599 11.125L34.5916 11.5475"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.322 17.1363V9.10938"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1246 19.968L44.438 17.2812"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EnhancesRecoveryIcon;
